export default __webpack_public_path__ + "static/media/how-to-use-2.6e4bc4a5.webp";